<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tUJMeb/tc-custom/9780814344682.jpg?1688985069241" alt="This image is the cover for the book United States Jewry, 1776-1985"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">United States Jewry, 1776-1985
      </h1>
      <p class="bookDescription body article font2">
        <p>In United States Jewry, 1776–1985, the dean of American Jewish historians, Jacob Rader Marcus, unfolds the history of Jewish immigration, segregation, and integration; of Jewry’s cultural exclusiveness and assimilation; of its internal division and indivisible unity; and of its role in the making of America. Characterized by Marcus’s impeccable scholarship, meticulous documentation, and readable style, this landmark four-volume set completes the history Marcus began in The Colonial American Jew, 1492–1776. Volume I focuses on the American revolution and the early national period, from 1776 to 1840. Marcus examines the role played by Jews in the revolution and discusses important historical and social themes such as politics, commerce, religion, Jewish and American culture, anti-Jewish prejudices, and the phenomenon of assimilation.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jacob Rader Marcus
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wayne State University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?727dcbd1